export default function setCookie(name: string, value: string, days: number | 'NA' = 'NA') {
  if (days === 'NA') {
    document.cookie = name + '=' + value + ';path=/;expires=N/A';
  } else {
    const expDate = new Date();

    expDate.setTime(expDate.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + '=' + value + ';path=/;expires=' + expDate.toUTCString();
  }
}
